import React from 'react';
import styles from './styles/RegisteredLandingLayout.module.css';

export default function OnboardingSteps({
  onAddLearner,
  onBrowseClasses,
}) {
  return (
    <div className={styles.stepsGrid}>
      <div className={styles.stepCard}>
        <span className={styles.stepBadge}>Step 1</span>
        <h2 className={styles.stepTitle}>Add your learner</h2>
        <p className={styles.stepText}>
          Tell us your child&apos;s age so we can suggest the right
          classes.
        </p>
        <button
          type="button"
          onClick={onAddLearner}
          className={styles.primaryButton}
        >
          Add your learner
        </button>
      </div>

      <div className={styles.stepCard}>
        <span className={styles.stepBadge}>Step 2</span>
        <h2 className={styles.stepTitle}>Pick a class</h2>
        <p className={styles.stepText}>
          Browse small-group, live classes taught by engaging tutors. Filter by
          subject.
        </p>
        <button
          type="button"
          onClick={onBrowseClasses}
          className={styles.secondaryButton}
        >
          Browse classes
        </button>
      </div>

      <div className={styles.stepCard}>
        <span className={styles.stepBadge}>Step 3</span>
        <h2 className={styles.stepTitle}>Join your first session</h2>
        <p className={styles.stepText}>
          After you enroll, you&apos;ll receive email confirmation and all of the details
          will be displayed on this page and your student page.
        </p>
      </div>
    </div>
  );
}